
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_388_425)","stroke":"#826BF8","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7 8.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM5 14v-.667c0-.353.132-.692.366-.943.235-.25.552-.39.884-.39h2.5c.332 0 .65.14.884.39.234.25.366.59.366.943V14M10 3.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM11 7h1.5c.398 0 .78.14 1.06.39.282.25.44.59.44.943V9M3 3.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM2 9v-.667c0-.353.158-.692.44-.942A1.6 1.6 0 013.5 7H5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_388_425"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    